/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import { PBSLink } from '../../atoms/link';
// import footerImage from '../../../assets/ppc-awards-footer.png';

const Footer = ({ footerContent }) => (
	<footer className="font-lexend-light">
		<div className="p-5 text-sm text-white md:p-10 bg-brand-blue-400">
			<div className="mx-auto lg:container">
				<div className="flex flex-col gap-8 lg:gap-20 lg:flex-row">
					<div className="flex flex-wrap">
						<ul className="flex flex-wrap w-full mt-4 2xl:mt-0 2xl:w-auto">
							{footerContent?.footerNavigationItems?.map(
								(site) => (
									<li
										key={`footer-int-sites-${site.link}`}
										className="mb-4 mr-4"
									>
										<PBSLink to={site.link} variant="Unset">
											{site.title}
										</PBSLink>
									</li>
								)
							)}
						</ul>
						<p className="w-full mt-4 leading-6">
							{footerContent.footerCopyright}
						</p>
					</div>
					<div className="flex flex-wrap items-center gap-4 shrink-0">
						<img
							src={footerContent?.footerImageCa?.url}
							alt="Canadian Awards"
							className="max-h-[123px] mx-auto lg:ml-auto"
						/>
					</div>
				</div>
			</div>
		</div>
	</footer>
);

Footer.propTypes = {
	footerContent: PropTypes.shape({
		footerNavigation: PropTypes.arrayOf(
			PropTypes.shape({
				title: PropTypes.string.isRequired,
				treeChildren: PropTypes.arrayOf(
					PropTypes.shape({
						link: PropTypes.string.isRequired,
						title: PropTypes.string.isRequired,
					})
				).isRequired,
			})
		).isRequired,
		footerAddressTitle: PropTypes.string.isRequired,
		footerAddress: PropTypes.string.isRequired,
		footerSocialTitle: PropTypes.string.isRequired,
		footerInternationalSitesCopy: PropTypes.string.isRequired,
		footerInternationalSites: PropTypes.arrayOf(
			PropTypes.shape({
				title: PropTypes.string.isRequired,
				link: PropTypes.string.isRequired,
			})
		).isRequired,
		footerCopyright: PropTypes.string.isRequired,
	}).isRequired,
};

export { Footer };
